/* ILARA London — drawer + newsletter behaviour.
   Ported from the approved design. Cart opening is delegated to
   Horizon's own <theme-drawer id="cart-drawer">, so cart state stays real. */
(function () {
  var scrim = document.getElementById('scrim');
  var open = null;

  function show(id) {
    var el = document.getElementById(id);
    if (!el || !scrim) return;
    close();
    el.classList.add('on');
    el.setAttribute('aria-hidden', 'false');
    scrim.hidden = false;
    requestAnimationFrame(function () { scrim.classList.add('on'); });
    document.body.style.overflow = 'hidden';
    open = el;
    var f = el.querySelector('[data-close]');
    if (f) f.focus();
  }

  function close() {
    if (!open) return;
    open.classList.remove('on');
    open.setAttribute('aria-hidden', 'true');
    if (scrim) scrim.classList.remove('on');
    document.body.style.overflow = '';
    open = null;
    setTimeout(function () {
      if (scrim && !document.querySelector('.drawer.on')) scrim.hidden = true;
    }, 320);
  }

  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-open]');
    if (o) { e.preventDefault(); show(o.getAttribute('data-open')); return; }
    if (e.target.closest('[data-close]')) { close(); return; }
    if (e.target === scrim) { close(); }
  });

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

  /* Header utilities delegate to Horizon's own components so search,
     cart state and checkout keep working. */
  document.addEventListener('click', function (e) {
    var cartBtn = e.target.closest('[data-ilara-cart]');
    if (cartBtn) {
      var drawer = document.querySelector('theme-drawer#cart-drawer');
      if (drawer && typeof drawer.toggle === 'function') {
        e.preventDefault();
        close();
        drawer.toggle();
      }
      return;
    }
    var searchBtn = e.target.closest('[data-ilara-search]');
    if (searchBtn) {
      var modal = document.getElementById('search-modal');
      if (modal && typeof modal.showDialog === 'function') {
        e.preventDefault();
        close();
        modal.showDialog();
      }
    }
  });

  /* Keep the header bag count in step with the real cart. Horizon emits
     shopify:cart:lines-update with a promise resolving to the updated cart;
     a /cart.js read backs it up so the count is right either way. */
  function syncCount(n) {
    if (typeof n !== 'number') return;
    document.querySelectorAll('[data-ilara-cart-count]').forEach(function (el) {
      el.textContent = '(' + n + ')';
    });
    document.querySelectorAll('[data-ilara-cart]').forEach(function (el) {
      el.setAttribute('aria-label', n === 1 ? 'Open bag, 1 item' : 'Open bag, ' + n + ' items');
    });
  }

  function refetchCount() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) { if (cart) syncCount(cart.item_count); })
      .catch(function () {});
  }

  document.addEventListener('shopify:cart:lines-update', function (e) {
    var p = e && e.promise;
    if (p && typeof p.then === 'function') {
      p.then(function (result) {
        var n = result && result.cart && result.cart.totalQuantity;
        if (typeof n === 'number') syncCount(n);
        else refetchCount();
      }).catch(refetchCount);
    } else {
      refetchCount();
    }
  });
})();
